Date.prototype.addDays = addDays
Date.prototype.format = format

String.prototype.replaceAll = replaceAll

Array.prototype.sortAndActive = sortAndActive

interface Array<T> {
  sortAndActive: typeof sortAndActive
}

interface Date {
  addDays: typeof addDays
  format: typeof format
}

interface String {
  replaceAll: typeof replaceAll
}

function addDays(days): Date {
    var dat = new Date(this.valueOf())
    dat.setDate(dat.getDate() + days)
    return dat
}

function format(fmt) {

    var D = "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","),
    M = "January,February,March,April,May,June,July,August,September,October,November,December".split(",");
    var me = this;
    return fmt.replace(/a|A|Z|S(SS)?|ss?|mm?|HH?|hh?|D{1,4}|M{1,4}|YY(YY)?|'([^']|'')*'/g, function(str) {
      var c1 = str.charAt(0),
          ret = str.charAt(0) == "'"
          ? (c1=0) || str.slice(1, -1).replace(/''/g, "'")
          : str == "a"
            ? (me.getHours() < 12 ? "am" : "pm")
            : str == "A"
              ? (me.getHours() < 12 ? "AM" : "PM")
              : str == "Z"
                ? (("+" + -me.getTimezoneOffset() / 60).replace(/^\D?(\D)/, "$1").replace(/^(.)(.)$/, "$10$2") + "00")
                : c1 == "S"
                  ? me.getMilliseconds()
                  : c1 == "s"
                    ? me.getSeconds()
                    : c1 == "H"
                      ? me.getHours()
                      : c1 == "h"
                        ? (me.getHours() % 12) || 12
                        : (c1 == "D" && str.length > 2)
                          ? D[me.getDay()].slice(0, str.length > 3 ? 9 : 3)
                          : c1 == "D"
                            ? me.getDate()
                            : (c1 == "M" && str.length > 2)
                              ? M[me.getMonth()].slice(0, str.length > 3 ? 9 : 3)
                              : c1 == "m"
                                ? me.getMinutes()
                                : c1 == "M"
                                  ? me.getMonth() + 1
                                  : ("" + me.getFullYear()).slice(-str.length);
      return c1 && str.length < 4 && ("" + ret).length < str.length
        ? ("00" + ret).slice(-str.length)
        : ret;
    });
    
}

function replaceAll(target, replacement) {
  return this.split(target).join(replacement)
}

function sortAndActive() {
  return this.filter(obj => obj.active).sort(function (a, b) { if (a.sortorder < b.sortorder) return -1; if (a.sortorder > b.sortorder) return 1; return 0; })
}
  